// extracted by mini-css-extract-plugin
export default {"singleLine":"TasksList_singleLine__5K2Xt"};